export const OVERDUE_TASKS_NOTIFICATION_SETTINGS_PATH =
  "/settings-menu/overdue-tasks-notification-settings";
